
import Box from '@mui/material/Box';
import styled from 'styled-components';

export const Container = styled(Box)`
    background-color: #FFFF;
    box-shadow: 24px;
    padding: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 50%;
`;